import { render } from "./ExpertStatisticsOutboundTrunk.vue?vue&type=template&id=8022a4b8"
import script from "./ExpertStatisticsOutboundTrunk.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOutboundTrunk.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOutboundTrunk.vue?vue&type=style&index=0&id=8022a4b8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__